var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showKeyWord
        ? _c("el-input", {
            staticStyle: { width: "200px", "margin-right": "10px" },
            on: { change: _vm.handTagInput },
            model: {
              value: _vm.keyWord,
              callback: function ($$v) {
                _vm.keyWord = $$v
              },
              expression: "keyWord",
            },
          })
        : _vm._e(),
      _vm._l(_vm.selectedTags, function (tag, index) {
        return _c(
          "el-tag",
          {
            key: index,
            staticClass: "singleTag",
            staticStyle: { "margin-right": "10px" },
            attrs: { closable: !_vm.disabled },
            on: {
              close: function ($event) {
                return _vm.handleCloseTag(tag)
              },
            },
          },
          [_vm._v(_vm._s(tag))]
        )
      }),
      _c("el-button", {
        attrs: {
          type: !_vm.showKeyWord ? "" : "success",
          plain: "",
          size: "small",
          icon: !_vm.showKeyWord ? "el-icon-plus" : "el-icon-check",
        },
        on: { click: _vm.handShowInput },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }